<template>
  <user-manager
    v-bind:canEdit="false"
    v-bind:functionalRoles="functionalRoles"
    v-bind:context="'kiosk-resident'"
    v-bind:showAssignedResidents="true"
    v-bind:canChangeRole="true"
    v-bind:toolbarColor="appColor_ResidentLight"
    v-bind:toolbarColorDark="appColor_Resident"
    />
</template>

<script>
import UserManager from '@/components/UserManager'
import { AppColor } from '@/config.js'

export default {
  name: "GenieKioskResidentContacts",
  data() {
    return {
      appColor_ResidentLight: AppColor.ResidentLight,
      appColor_Resident: AppColor.Resident
    }
  },
  computed: {
    functionalRoles () {
      return [
        this.getExpression('FunctionalRole', 'VirtualVisitor'),
        this.getExpression('FunctionalRole', 'FamilyFacilitator')
      ]
    }
  },
  components: {
    UserManager
  }
}
</script>